import { render, staticRenderFns } from "./lxwm.vue?vue&type=template&id=3697e7b5&scoped=true&"
import script from "./lxwm.vue?vue&type=script&lang=js&"
export * from "./lxwm.vue?vue&type=script&lang=js&"
import style0 from "./lxwm.vue?vue&type=style&index=0&id=3697e7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3697e7b5",
  null
  
)

export default component.exports